{
	"aiHealingApiKeyError": "API key error. Please check your configuration.",
	"aiHealingCorsError": "API access error. Please check your network configuration.",
	"aiHealingFailedError": "AI healing failed. Please try again.",
	"aiHealingFailedWithDetail": "AI healing failed: {{detail}}",
	"aiHealingGenericError": "Something went wrong. Please try again later.",
	"aiHealingImageTooLargeError": "Image is too large. Try using a smaller image or lower quality.",
	"aiHealingInvalidRequestError": "Invalid request. Please check your prompt and try again.",
	"aiHealingNetworkError": "Network connection error. Please check your internet and try again.",
	"aiHealingNetworkInterruptedError": "Generation interrupted due to internet connection loss.",
	"aiHealingNsfwBlockedError": "Your prompt or image was flagged by the safety filter. Please revise and try again.",
	"aiHealingOutOfCredits": "You are out of Gen-AI credits",
	"aiHealingRateLimitError": "Too many requests. Please wait a moment before trying again.",
	"aiHealingResultDiscarded": "Warning: Photo was closed, {{message}} result discarded",
	"aiHealingSavedToPrevious": "{{message}} finished and saved to previous photo",
	"aiHealingServiceUnavailableError": "AI service temporarily unavailable. Please try again in a moment.",
	"aiHealingTimeoutError": "Request timed out. Please try again.",
	"aiHealingVariationLimit": "Variation limit reached for this AI edit"
}
